import React, { FC } from "react";
import { FullWidthLayout, SectionLayout } from "@/layouts";
import { useTranslation } from "react-i18next";
import * as Styled from "./mainContact.styles";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@cellectenergy/cellect-react-components";

export const MainScreenContact: FC = () => {
  const { t } = useTranslation("global");
  const theme = useTheme();
  return (
    <Box width={"100%"} height={"100%"} position={"relative"}>
      <Styled.MainContainer
        sx={{
          minHeight: { xs: "578px" },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "60%",
            backgroundImage:
              "linear-gradient(to bottom, rgba(3, 31, 50, 0) 0%, rgba(3, 31, 50, 1) 100%)",
            zIndex: 2,
          }}
        />
        <Box
          width={"100%"}
          maxWidth={"1440px"}
          display={"flex"}
          flexDirection={"column"}
          margin={"0 auto"}
          zIndex={3}
          sx={{
            padding: {
              xs: "2rem 1rem",
              md: "2rem 1.5rem",
              lg: "3rem 2rem",
            },
          }}
          gap={"1.5rem"}
        >
          <Typography
            width={{ xs: "70%", md: "30%" }}
            color={theme.palette.common.corporateColors.primary.white}
            variant="display-small"
            fontWeight={500}
          >
            {t("contactMain.title")}
          </Typography>
          <Typography
            width={{ md: "50%", lg: "100%" }}
            color={theme.palette.common.corporateColors.primary.white}
            variant="title-large"
          >
            {t("contactMain.description")}
          </Typography>
        </Box>
      </Styled.MainContainer>
    </Box>
  );
};
